import config from './config';
import { getBearerString } from './jwt_token';

const query_data = async (extension, request_body, method = null) => {
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': getBearerString()
    };

    // Handle cases where the token might be missing.
    if (!headers.Authorization || headers.Authorization === "Bearer null" || headers.Authorization === "Bearer undefined") {
        console.error("Authentication token not found. Aborting request.");
        // Redirect to login if not already there.
        if (window.location.pathname !== "/login") {
            localStorage.removeItem("isaacToken");
            window.location.href = "/login";
        }
        throw new Error("Authentication token not found.");
    }

    const link = config.data_platform_api_url + extension;

    const fetchOptions = {
        method: 'GET', // Default to GET
        headers: headers,
    };

    if (method) {
        fetchOptions.method = method;
    } else if (request_body && Object.keys(request_body).length > 0) {
        fetchOptions.method = 'POST';
    }

    if (fetchOptions.method !== 'GET' && request_body) {
        fetchOptions.body = JSON.stringify(request_body);
    }

    const response = await fetch(link, fetchOptions);

    if (response.status === 401) {
        // Unauthorized: token is invalid or expired.
        localStorage.removeItem("isaacToken");
        if (window.location.pathname !== "/login") {
            window.location.href = "/login";
        }
        throw new Error("Unauthorized");
    }

    if (!response.ok) {
        const errorText = await response.text();
        console.error(`HTTP error! status: ${response.status}, body: ${errorText}`);
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Handle responses with no content, common for DELETE requests
    if (response.status === 204) {
        return;
    }

    const text = await response.text();
    // Handle empty response body
    return text ? JSON.parse(text) : {};
}

export default query_data;